// extracted by mini-css-extract-plugin
export default {"textShieldRootV2":"textShieldRootV2___J86s_","s":"s___GuZEl","m":"m___r12nG","l":"l___AYk6L","static":"static____CmkA","textShieldImgV2":"textShieldImgV2___b4rCp"};